var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833496 3.33317V16.6665C0.833496 17.1085 1.00909 17.5325 1.32165 17.845C1.63421 18.1576 2.05814 18.3332 2.50016 18.3332H12.5002C12.9422 18.3332 13.3661 18.1576 13.6787 17.845C13.9912 17.5325 14.1668 17.1085 14.1668 16.6665V6.9515C14.1668 6.72947 14.1224 6.50968 14.0363 6.30504C13.9501 6.1004 13.8239 5.91504 13.6652 5.75984L9.96516 2.1415C9.6538 1.83705 9.23564 1.66656 8.80016 1.6665H2.50016C2.05814 1.6665 1.63421 1.8421 1.32165 2.15466C1.00909 2.46722 0.833496 2.89114 0.833496 3.33317V3.33317Z",
    stroke: "#6AA287",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.833H10",
    stroke: "#6AA287",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.1665H7.5",
    stroke: "#6AA287",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16699 1.6665V4.99984C9.16699 5.44186 9.34259 5.86579 9.65515 6.17835C9.96771 6.49091 10.3916 6.6665 10.8337 6.6665H14.167",
    stroke: "#6AA287",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.c4c22a94d4240b269e1fa07bc8e105a5.svg";
export { ForwardRef as ReactComponent };